import en from './en';
import locolizeData from './eda-dfae-bundle.json';

/*
Tag cms
https://localise.biz/appswithlove/eda-dfae#!l=148173&m=7
*/
export const locolize = locolizeData;

export default {
    en,
};
